import noImage from "../images/no-image-small.png";

const MISSING_VALUES = new Set(["", "null", "undefined"]);

export const introductionPhotoSrc = (intro) => {
  const photo = intro?.Photo_1;
  if (typeof photo !== "string") return noImage;
  const trimmed = photo.trim();
  return MISSING_VALUES.has(trimmed) ? noImage : trimmed;
};

export const introductionPhotoAlt = (propertyName, location) => {
  const name = String(propertyName || "").trim() || "Introduced home";
  const place = String(location || "").replace(/^[\s,]+|[\s,]+$/g, "");
  return place ? `${name} in ${place}` : name;
};

export const showPlaceholderOnError = (event) => {
  const image = event?.currentTarget;
  if (!image || image.getAttribute("src") === noImage) return;
  image.src = noImage;
};
